import { cookieManager } from "@/_old/utils/cookie-manager";

export function getCookie(cookieName: string) {
  return cookieManager.get<string>({
    cookieName,
  });
}

export function setCookie(
  cookieName: string,
  value: string,
  options?: {
    expirationDate?: Date;
    globally?: boolean;
    path?: string;
  },
) {
  return cookieManager.set({ cookieName, value, ...options });
}

export function removeCookie(
  cookieName: string,
  options?: {
    globally?: boolean;
    path?: string;
  },
) {
  return cookieManager.remove({ cookieName, ...options });
}
